import { render } from "./MailingBlockImage.vue?vue&type=template&id=3acbad80"
import script from "./MailingBlockImage.vue?vue&type=script&lang=js"
export * from "./MailingBlockImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__